import { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import InputLabel from '@mui/material/InputLabel';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';
import Switch from '@mui/material/Switch';

import { getEvaAgentsAPI } from '../../../../services/getEvaAgents.service';

import styles from '../Intimidad/Intimidad.module.css';

export const EvaAgentsConfig = ({
  haveAnalysis,
  handleHaveAnalysis,
  reportConfigurationIds,
  setReportConfigurationIds,
}) => {
  const [agents, setAgents] = useState([]);

  useEffect(() => {
    getEvaAgentsAPI()
      .then((res) => setAgents(res.data))
      .catch((e) => console.log(e));
  }, []);

  const handleAgentChange = (event) => {
    const { value } = event.target;
    setReportConfigurationIds(
      typeof value === 'string' ? value.split(',').map(Number) : value,
    );
  };

  return (
    <div className={styles.intimidad}>
      <div className={styles.top}>
        <Typography
          variant="h6"
          style={{ fontWeight: 'bold', marginBottom: '15px' }}
        >
          La encuesta tiene agentes de IA?
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Al marcar esta opción podrás seleccionar uno o más agentes de IA
          asociados a esta encuesta.
        </Typography>
      </div>
      <div
        className={styles.bottom}
        style={{ flexDirection: 'column', gap: '1rem' }}
      >
        <FormControl>
          <FormControlLabel
            control={
              <Switch
                checked={haveAnalysis}
                onChange={(e) => handleHaveAnalysis(e.target.checked)}
              />
            }
            label={
              haveAnalysis
                ? 'Sí, tiene agentes de IA.'
                : 'No tiene agentes de IA.'
            }
          />
        </FormControl>

        {haveAnalysis && (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            <FormControl sx={{ minWidth: 320, maxWidth: 480 }}>
              <InputLabel id="eva-agents-label">Agentes de IA</InputLabel>
              <Select
                labelId="eva-agents-label"
                multiple
                value={reportConfigurationIds}
                onChange={handleAgentChange}
                input={<OutlinedInput label="Agentes de IA" />}
                renderValue={(selected) =>
                  `${selected.length} agente${selected.length !== 1 ? 's' : ''} seleccionado${selected.length !== 1 ? 's' : ''}`
                }
              >
                {agents.map((agent) => (
                  <MenuItem key={agent.id} value={agent.id}>
                    <Checkbox checked={reportConfigurationIds.includes(agent.id)} />
                    <ListItemText primary={agent.name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {reportConfigurationIds.length > 0 && (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                {reportConfigurationIds.map((id) => {
                  const agent = agents.find((a) => a.id === id);
                  return agent ? (
                    <Chip
                      key={id}
                      label={agent.name}
                      onDelete={() =>
                        setReportConfigurationIds((prev) => prev.filter((v) => v !== id))
                      }
                      color="primary"
                      variant="outlined"
                      size="small"
                    />
                  ) : null;
                })}
              </Box>
            )}
          </Box>
        )}
      </div>
    </div>
  );
};
